import React, { useState, useEffect, useRef } from "react";

const steps = [
  {
    num: "01",
    title: "ВАШИ ОЖИДАНИЯ",
    desc: "Вы приходите к нам с идеей, товаром и желанием зарабатывать на маркетплейсах. Возможно, вы уже пробовали сами — но не получили нужных результатов.",
    points: [
      "Хочу выйти на маркетплейсы, но не знаю с чего начать",
      "Не хватает времени разбираться в рекламе и аналитике",
      "Пробовал сам — продажи не растут",
      "Хочу стабильный доход с маркетплейсов",
    ],
  },
  {
    num: "02",
    title: "РАБОТА ПЕРВОГО СЕЛЛЕРА",
    desc: "Наша команда берёт на себя всю операционку. Настраиваем, оптимизируем, запускаем рекламу, ведём аналитику — вы занимаетесь своим бизнесом.",
    points: [
      "Аудит ниши и конкурентный анализ за 24 часа",
      "Запуск и управление рекламными кампаниями",
      "Создание и оптимизация карточек товаров",
      "Ежедневный мониторинг позиций и продаж",
      "Работа с отзывами и рейтингом",
      "Прозрачная отчётность на каждом шаге",
    ],
  },
  {
    num: "03",
    title: "РЕЗУЛЬТАТ",
    desc: "Ваши ожидания оправданы. Магазин работает, продажи растут, прибыль стабильна. Вы видите реальные цифры и понимаете — это было правильное решение.",
    points: [
      "Стабильный рост продаж из месяца в месяц",
      "Полная окупаемость вложений за 2–3 месяца",
      "Магазин в ТОП-выдачи по ключевым запросам",
      "Прозрачная unit-экономика и понятный ROI",
      "Масштабирование на другие площадки",
    ],
  },
];

function StepCard({ step, index, visible }) {
  const [hovered, setHovered] = useState(false);
  const delay = index * 0.18;

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: "relative",
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(48px)",
        transition: `opacity 0.7s cubic-bezier(0.16,1,0.3,1) ${delay}s, transform 0.7s cubic-bezier(0.16,1,0.3,1) ${delay}s`,
      }}
    >
      {/* Номер снаружи карточки */}
      <div style={{
        position: "absolute",
        top: "50%",
        [index % 2 === 0 ? "left" : "right"]: "-60px",
        transform: "translateY(-50%)",
        fontSize: 120,
        fontWeight: 900,
        lineHeight: 1,
        background: "linear-gradient(135deg, #22D3EE, #8B5CF6, #EC4899)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        opacity: 0.12,
        pointerEvents: "none",
        userSelect: "none",
        fontFamily: "'Inter', sans-serif",
      }}>
        {step.num}
      </div>

      {/* Card */}
      <div style={{
        background: hovered ? "rgba(255,255,255,0.07)" : "rgba(255,255,255,0.05)",
        border: hovered
          ? "1px solid rgba(139,92,246,0.25)"
          : "1px solid rgba(255,255,255,0.1)",
        borderRadius: 24,
        padding: 32,
        marginBottom: index < steps.length - 1 ? 12 : 0,
        cursor: "default",
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        boxShadow: hovered
          ? "0 20px 40px rgba(34,211,238,0.08), 0 0 60px rgba(139,92,246,0.06)"
          : "none",
        transition: "all 0.3s ease",
        position: "relative",
        overflow: "hidden",
      }}>
        <div style={{
          position: "absolute",
          top: -80,
          left: -80,
          width: 200,
          height: 200,
          borderRadius: "50%",
          background: "linear-gradient(135deg, rgba(34,211,238,0.08), rgba(139,92,246,0.06))",
          filter: "blur(40px)",
          opacity: hovered ? 1 : 0,
          transition: "opacity 0.4s ease",
          pointerEvents: "none",
        }} />

        <h3 style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: 22,
          fontWeight: 700,
          color: "#FFFFFF",
          margin: "0 0 12px 0",
          letterSpacing: "0.04em",
          textTransform: "uppercase",
          lineHeight: 1.3,
        }}>
          {step.title}
        </h3>

        <p style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: 15,
          fontWeight: 400,
          lineHeight: 1.6,
          color: "rgba(255,255,255,0.5)",
          margin: "0 0 24px 0",
          maxWidth: 580,
        }}>
          {step.desc}
        </p>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
          gap: "8px 24px",
        }}>
          {step.points.map((point, j) => (
            <div
              key={j}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                opacity: visible ? 1 : 0,
                transform: visible ? "translateX(0)" : "translateX(-16px)",
                transition: `all 0.5s cubic-bezier(0.16,1,0.3,1) ${delay + 0.3 + j * 0.06}s`,
              }}
            >
              <div style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #22D3EE, #8B5CF6)",
                flexShrink: 0,
                boxShadow: "0 0 8px rgba(34,211,238,0.4)",
              }} />
              <span style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: 14,
                fontWeight: 400,
                color: "rgba(255,255,255,0.7)",
                lineHeight: 1.5,
              }}>
                {point}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function CooperationStages() {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 600);
    return () => clearTimeout(t);
  }, []);

  return (
    <section
      ref={ref}
      style={{
        background: "#0F0F1A",
        padding: "100px 24px",
        position: "relative",
        overflow: "hidden",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* Background glow — top left */}
      <div style={{
        position: "absolute",
        top: -100,
        left: -100,
        width: 450,
        height: 450,
        borderRadius: "50%",
        background: "linear-gradient(135deg, #22D3EE, #8B5CF6)",
        filter: "blur(140px)",
        opacity: 0.08,
        pointerEvents: "none",
        animation: "glowDrift1 12s ease-in-out infinite",
      }} />

      {/* Background glow — bottom right */}
      <div style={{
        position: "absolute",
        bottom: -80,
        right: -60,
        width: 400,
        height: 400,
        borderRadius: "50%",
        background: "linear-gradient(135deg, #EC4899, #FBBF24)",
        filter: "blur(120px)",
        opacity: 0.06,
        pointerEvents: "none",
        animation: "glowDrift2 10s ease-in-out infinite",
      }} />

      {/* Decorative background icons */}
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: "none",
        zIndex: 0,
      }}>
        <img
                loading="lazy"
          src="/images/icons/rocket.webp"
          alt=""
          className="coop-bg-icon coop-bg-icon-1"
        />
        <img
                loading="lazy"
          src="/images/icons/chart.webp"
          alt=""
          className="coop-bg-icon coop-bg-icon-2"
        />
        <img
                loading="lazy"
          src="/images/icons/trophy.webp"
          alt=""
          className="coop-bg-icon coop-bg-icon-3"
        />
        <img
                loading="lazy"
          src="/images/icons/star.webp"
          alt=""
          className="coop-bg-icon coop-bg-icon-4"
        />
      </div>

      <div style={{ maxWidth: 1000, margin: "0 auto", position: "relative", zIndex: 1 }}>
        {/* Section header */}
        <div style={{
          textAlign: "center",
          marginBottom: 72,
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(32px)",
          transition: "all 0.7s cubic-bezier(0.16,1,0.3,1)",
        }}>
          <div style={{
            display: "inline-block",
            background: "rgba(255,255,255,0.1)",
            color: "#FFFFFF",
            fontSize: 14,
            fontWeight: 500,
            padding: "12px 24px",
            borderRadius: 50,
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            marginBottom: 28,
          }}>
            Этапы работы
          </div>

          <h2 style={{
            fontSize: "clamp(32px, 5vw, 48px)",
            fontWeight: 800,
            textTransform: "uppercase",
            letterSpacing: "-1px",
            lineHeight: 1.1,
            margin: 0,
            color: "#fff",
          }}>
            Как проходит{" "}
            <span style={{
              background: "linear-gradient(90deg, #22D3EE 0%, #8B5CF6 50%, #EC4899 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}>
              сотрудничество
            </span>
          </h2>

          <p style={{
            fontSize: 16,
            fontWeight: 400,
            color: "rgba(255,255,255,0.45)",
            marginTop: 16,
            lineHeight: 1.6,
          }}>
            От ваших ожиданий — к реальному результату
          </p>
        </div>

        {/* Timeline steps */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          {steps.map((step, i) => (
            <StepCard key={i} step={step} index={i} visible={visible} />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes glowDrift1 {
          0%, 100% { transform: translate(0, 0); }
          50% { transform: translate(30px, 20px); }
        }
        @keyframes glowDrift2 {
          0%, 100% { transform: translate(0, 0); }
          50% { transform: translate(-25px, -15px); }
        }

        /* Decorative background icons */
        .coop-bg-icon {
          position: absolute;
          opacity: 0.05;
          filter: blur(1px) grayscale(0.3);
        }

        .coop-bg-icon-1 {
          width: 100px;
          height: 100px;
          top: 8%;
          left: 4%;
          transform: rotate(-12deg);
          animation: floatCoop1 6s ease-in-out infinite;
        }

        .coop-bg-icon-2 {
          width: 100px;
          height: 100px;
          top: 15%;
          right: 5%;
          transform: rotate(10deg);
          animation: floatCoop2 7s ease-in-out infinite;
        }

        .coop-bg-icon-3 {
          width: 100px;
          height: 100px;
          bottom: 12%;
          left: 5%;
          transform: rotate(8deg);
          animation: floatCoop3 5.5s ease-in-out infinite;
        }

        .coop-bg-icon-4 {
          width: 100px;
          height: 100px;
          bottom: 15%;
          right: 4%;
          transform: rotate(-10deg);
          animation: floatCoop4 6.5s ease-in-out infinite;
        }

        @keyframes floatCoop1 {
          0%, 100% { transform: translate(0, 0) rotate(-12deg); }
          50% { transform: translate(-10px, -12px) rotate(-12deg); }
        }

        @keyframes floatCoop2 {
          0%, 100% { transform: translate(0, 0) rotate(10deg); }
          50% { transform: translate(10px, -15px) rotate(10deg); }
        }

        @keyframes floatCoop3 {
          0%, 100% { transform: translate(0, 0) rotate(8deg); }
          50% { transform: translate(-12px, -10px) rotate(8deg); }
        }

        @keyframes floatCoop4 {
          0%, 100% { transform: translate(0, 0) rotate(-10deg); }
          50% { transform: translate(14px, -14px) rotate(-10deg); }
        }

        @media (max-width: 768px) {
          .coop-bg-icon { display: none; }
        }
      `}</style>
    </section>
  );
}
